import { getFingerprint } from '@eureka/services/src/apis/interceptors/fingerprint.interceptor';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { BiTrackApi } from '../../apis/bi-track-api';
import type { BiTrackRepository } from '../../services/bi-track-repository';
import type { BiTrackEventType } from '../../types';

@injectable()
export class BiTrackRepositoryImpl implements BiTrackRepository {
    constructor(
        @inject(BiTrackApi) private _biTrackApi: BiTrackApi
    ) { }

    biTrack(eventType: string, data: BiTrackEventType) {
        const { sourceType, otherParam, eventDetailStr } = data;
        const signatureId = getFingerprint();
        let detailStr: string | undefined;

        // 如果未登录，需要添加signatureId
        if (signatureId) {
            if (!_.isString(eventDetailStr)) {
                // eventDetailStr是对象或undefined/null
                const dataObj = eventDetailStr || {};
                detailStr = JSON.stringify({ ...dataObj, signatureId });
            } else if (!eventDetailStr) {
                // eventDetailStr是空字符串
                detailStr = JSON.stringify({ signatureId });
            } else {
                // eventDetailStr是非空字符串
                try {
                    const dataObj = JSON.parse(eventDetailStr);
                    detailStr = JSON.stringify({ ...dataObj, signatureId });
                } catch {
                    // 不是有效JSON，保留原字符串
                    detailStr = eventDetailStr;
                }
            }
        } else {
            // 已登录，保持原逻辑
            if (!_.isString(eventDetailStr)) {
                detailStr = eventDetailStr ? JSON.stringify(eventDetailStr) : undefined;
            } else {
                detailStr = eventDetailStr || undefined;
            }
        }

        return this._biTrackApi.biTrack({
            event_type: eventType,
            source_type: sourceType,
            other_param: otherParam,
            event_detail_str: detailStr,
            module_type: 'EUREKA',
        });
    }
}
